import React from "react";
import { Ratio } from "react-bootstrap";

function VideoComponent(props) {

    return (
        <div className="row">
            <div className="col ">
                <div className="container d-none d-lg-block ">
                    <div className="row">
                        <div className="col p-0">
                            <Ratio aspectRatio={1 / 3}>
                                <iframe
                                    src={props.data.data.ContentJson.FLD_0_1_10_10}
                                    title="YouTube video"
                                    className=" rounded rounded-5"

                                ></iframe>
                            </Ratio>
                        </div>

                    </div>
                </div>
                <div className="container-fluid d-lg-none p-0">
                    <div className="row">
                        <div className="col p-0">
                            <Ratio aspectRatio={1 / 2}>
                                <iframe
                                    src={props.data.data.ContentJson.FLD_0_1_10_10}
                                    title="YouTube video"

                                ></iframe>
                            </Ratio>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default VideoComponent